import { ButtonBase, DialogContent, DialogTitle, Grid } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import { useCurrentUser } from '@src/utils/useCurrentUser'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => {
  return {
    dialogHeader: {
      padding: theme.spacing(3, 0, 0, 0),
      textAlign: 'right',
    },
    closeIcon: {
      fontSize: theme.typography.pxToRem(30),
    },
    body: {
      paddingTop: theme.spacing(0),
      minWidth: '100%',
      overflowY: 'hidden',
      [theme.breakpoints.up('md')]: {
        minWidth: theme.spacing(145),
      },
    },
    dialog: {
      padding: theme.spacing(0, 8, 0, 5),
      height: '100%',
      flexDirection: 'column',
    },
  }
})

interface Props {
  formPageCount: number
  setFormPageCount: (number) => void
  handleClose: () => void
}

const PurchaseTermsAndConditions: React.FC<Props> = ({
  // formPageCount,
  setFormPageCount,
  handleClose,
}) => {
  const classes = useStyles()
  const { currentUser } = useCurrentUser()

  if (currentUser?.__typename !== 'LoggedInUser') return null

  const address = `${
    currentUser.contactAddress.street
      ? ' ' + currentUser.contactAddress.street
      : ''
  }${
    currentUser.contactAddress.street2
      ? ' ' + currentUser.contactAddress.street2
      : ''
  }${
    currentUser.contactAddress.street3
      ? ' ' + currentUser.contactAddress.street3
      : ''
  }${
    currentUser.contactAddress.street4
      ? ' ' + currentUser.contactAddress.street4
      : ''
  }${
    currentUser.contactAddress.city ? ' ' + currentUser.contactAddress.city : ''
  }${
    currentUser.contactAddress.state
      ? ' ' + currentUser.contactAddress.state
      : ''
  }`

  const urlParams = `tfa_5=${
    currentUser.organizationName ? currentUser.organizationName.trim() : ''
  }
  &tfa_7=${currentUser.firstName ? currentUser.firstName.trim() : ''}
  ${currentUser.lastName ? ' ' + currentUser.lastName.trim() : ''} 
    &tfa_9=${address.trim()}
    &tfa_11=${
      currentUser.contactAddress.country
        ? currentUser.contactAddress.country.trim()
        : ''
    }
    &tfa_13=${
      currentUser.contactAddress.telephone
        ? currentUser.contactAddress.telephone.trim()
        : ''
    }
    &tfa_15=${
      currentUser.contactAddress.email
        ? currentUser.contactAddress.email.trim()
        : ''
    }`

  return (
    <Grid container direction="row-reverse" className={classes.dialog}>
      <DialogTitle disableTypography classes={{ root: classes.dialogHeader }}>
        <ButtonBase id="emproveDialog" onClick={() => handleClose()}>
          <CloseIcon classes={{ root: classes.closeIcon }} />
        </ButtonBase>
      </DialogTitle>
      {/* we are currently rendering form 7729 - this is a test form. actual will be 3659 */}
      <DialogContent className={classes.body}>
        {/* TODO: Replace this form with one created in react */}
        <iframe
          src={`https://sial.tfaforms.net/7729?${urlParams}&tfa_16=${window.location.origin}/emproveformthankyou.html`}
          style={{
            overflow: 'hidden',
            border: 'none',
            width: '100%',
            height: '100%',
          }}
          frameBorder="0"
          title="emproveTermsConditions"
          onLoad={() => setFormPageCount(0)}
        />
      </DialogContent>
    </Grid>
  )
}

export default PurchaseTermsAndConditions
